import React, { ChangeEvent, useEffect, useState } from "react";
import { Button, Popover, Box, FormControl, MenuItem, Select, DialogActions } from "@mui/material";
import { UploadPropertiesXml } from "../../Services/Properties";
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from "react-i18next";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const UploadProperties: React.FunctionComponent<{ OnUploadXml: any }> = (props) => {

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;
    const [nameFileXml, setNameFileXml] = useState<any>("");
    const [formData, setFormData] = useState({
        xmlData: "",
        url: "",
        platform: ""
    });
    const [platforms, setPlatforms] = useState<any>([{ name: "Coralytics", src: "/assets/images/icons/coralytics.webp" }, { name: "Propcrm", src: "/assets/images/icons/propcrm.png" }, { name: "Propertyfinder", src: "/assets/images/icons/finder.png" }, { name: "Bayut", src: "/assets/images/icons/bayut.png" }, { name: "Dubizzle", src: "/assets/images/icons/dubizzle.png" }]);
    const [isSpinner, setIsSpinner] = useState<boolean>(false);
    const [openDialog, setOpenDialog] = useState<boolean>(false);
    const [dialogType, setDialogType] = useState<string>("");
    const { t } = useTranslation();


    const handleCloseDialog = () => {
        setOpenDialog(false)
    }

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    /************handle platform change************ */
    const handleChangedPlatform = (event: any) => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            platform: event.target.value,
        }));
    };

    /************handle File Change************ */

    const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        setNameFileXml(event.target.files?.[0].name)
        if (file) {
            const reader = new FileReader();

            reader.onload = (e) => {
                const xmlContent = e.target?.result as string;
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    xmlData: xmlContent,
                }));
            };
            reader.readAsText(file);
        }
    };

    /************Create new property************ */

    const send = (formData: any) => {
        setIsSpinner(true)
        UploadPropertiesXml(formData).then((data) => {
            setFormData({
                xmlData: "",
                url: "",
                platform: ""
            })
            setIsSpinner(false)
            const obj = {
                msg: data.message,
                color: "success"
            }
            props.OnUploadXml(obj)

        }).catch((error: any) => {
            setIsSpinner(false)
            const obj = {
                msg: error.response.data,
                color: "error"
            }
            props.OnUploadXml(obj)
        })
    };

    const handleOpenDialog = (type: string) => {
        setDialogType(type)
        setOpenDialog(true)
    }

    return (<>
        <Box>
            <button
                aria-describedby={id}
                onClick={handleClick}
                className="button-dash border-746AFF color-746AFF back-trans padd-15-30 padd-15-mb marg-right-16"
            >
                <svg width="16" height="16" className="size-20 display-none-web" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_683_547)">
                        <path d="M8 3.3335V12.6668" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M3.33203 8H12.6654" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_683_547">
                            <rect width="16" height="16" fill="white" />
                        </clipPath>
                    </defs>
                </svg>

                <span className="display-none-mb">{t('propertiesPage.upload')}</span>
                {isSpinner && <div className="spinner-border text-white size-20" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>}
            </button>

            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
                PaperProps={{
                    sx: {
                        padding: 0,
                        overflow: "visible",
                        background: "#FFFFFF",
                        borderRadius: "7px",
                        marginTop: "15px",
                        boxShadow: "0px 0px 0px transparent !important"
                    },
                }}
            >
                <Box
                    sx={{
                        position: "relative",
                        display: "flex",
                        backgroundColor: "white",
                        padding: "10px 5px",
                        borderRadius: "7px"
                    }}
                >
                    <Box
                        sx={{
                            position: "absolute",
                            top: "-10px",
                            left: "50%",
                            width: "0",
                            height: "0",
                            borderLeft: "10px solid transparent",
                            borderRight: "10px solid transparent",
                            borderBottom: "10px solid white",
                            transform: "translateX(-50%)",
                        }}
                    />
                    <Button
                        sx={{
                            background: "#FFFFFF",
                            border: "1px solid rgba(0, 0, 0, 0.2)",
                            borderRadius: "7px",
                            fontFamily: 'Plus Jakarta Sans',
                            fontStyle: "normal",
                            fontWeight: "700",
                            fontSize: "14px",
                            lineHeight: "18px",
                            color: "#000000 !important",
                            padding: "8px 16px",
                            margin: "0 10px",
                            textTransform: "none",
                            "&:hover": { backgroundColor: "#f5f5f5" },
                        }}
                        onClick={() => { handleOpenDialog("XML") }}
                    >
                        XML
                    </Button>
                    <Button
                        sx={{
                            background: "#FFFFFF",
                            border: "1px solid rgba(0, 0, 0, 0.2)",
                            borderRadius: "7px",
                            fontFamily: 'Plus Jakarta Sans',
                            fontStyle: "normal",
                            fontWeight: "700",
                            fontSize: "14px",
                            lineHeight: "18px",
                            color: "#000000 !important",
                            padding: "8px 16px",
                            margin: "0 10px",
                            textTransform: "none",
                            "&:hover": { backgroundColor: "#f5f5f5" },
                        }}
                        onClick={() => { handleOpenDialog("API") }}
                    >
                        API
                    </Button>
                </Box>
            </Popover >
        </Box >

        <BootstrapDialog
            open={openDialog}
            onClose={handleCloseDialog}
            aria-labelledby="customized-dialog-title"
            fullWidth={true}
            maxWidth={dialogType === "XML" ? "sm" : "md"}
        >
            <DialogTitle >
                <div className="title-20 mt-2">{dialogType === "XML" ? t('propertiesPage.upload') : t('propertiesPage.apiDocumentation')}</div>
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleCloseDialog}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[800],
                })}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent>
                {dialogType === "XML" ? <div className="row">
                    <div className="col-md-12 mb-3">
                        <label htmlFor="selectPlatform" className="para-16 mb-3">{t('propertiesPage.selectPlatform')}</label>
                        <FormControl fullWidth>
                            <Select
                                className="custom-select "
                                displayEmpty
                                inputProps={{ 'aria-label': "Select" }}
                                value={formData.platform}
                                onChange={handleChangedPlatform}
                                renderValue={(selected) => selected || `${t('propertiesPage.select')} `}
                                sx={{
                                    '.MuiOutlinedInput-notchedOutline': {
                                        border: 'none',
                                        borderRadius: "10px"
                                    },
                                }}
                            >
                                <MenuItem value="">
                                    {t('propertiesPage.select')}
                                </MenuItem>
                                {platforms.map((platform: any, index: any) => (
                                    <MenuItem key={index} value={platform.name} className="text-end">
                                        <img src={platform.src} style={{ width: "auto", maxHeight: "20px", marginRight: "10px" }} />
                                        {platform.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                    <div className="col-md-12">
                        <div className="upload-xml">
                            <label className="form__container padd-30" id="upload-container">
                                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.1618 8.99499L12.8335 6.31166V17.5C12.8335 17.8094 12.9564 18.1062 13.1752 18.3249C13.394 18.5437 13.6907 18.6667 14.0002 18.6667C14.3096 18.6667 14.6063 18.5437 14.8251 18.3249C15.0439 18.1062 15.1668 17.8094 15.1668 17.5V6.31166L17.8385 8.99499C17.947 9.10434 18.076 9.19113 18.2182 9.25036C18.3603 9.30959 18.5128 9.34009 18.6668 9.34009C18.8208 9.34009 18.9733 9.30959 19.1155 9.25036C19.2577 9.19113 19.3867 9.10434 19.4952 8.99499C19.6045 8.88653 19.6913 8.7575 19.7505 8.61533C19.8098 8.47316 19.8403 8.32067 19.8403 8.16666C19.8403 8.01264 19.8098 7.86015 19.7505 7.71798C19.6913 7.57582 19.6045 7.44678 19.4952 7.33832L14.8285 2.67166C14.7175 2.56544 14.5867 2.48218 14.4435 2.42666C14.1595 2.30997 13.8409 2.30997 13.5568 2.42666C13.4136 2.48218 13.2828 2.56544 13.1718 2.67166L8.50516 7.33832C8.39638 7.4471 8.3101 7.57624 8.25123 7.71837C8.19236 7.86049 8.16206 8.01282 8.16206 8.16666C8.16206 8.32049 8.19236 8.47282 8.25123 8.61495C8.3101 8.75707 8.39638 8.88621 8.50516 8.99499C8.61394 9.10377 8.74308 9.19006 8.88521 9.24893C9.02733 9.3078 9.17966 9.3381 9.3335 9.3381C9.48733 9.3381 9.63966 9.3078 9.78179 9.24893C9.92391 9.19006 10.0531 9.10377 10.1618 8.99499ZM24.5002 16.3333C24.1907 16.3333 23.894 16.4562 23.6752 16.675C23.4564 16.8938 23.3335 17.1906 23.3335 17.5V22.1667C23.3335 22.4761 23.2106 22.7728 22.9918 22.9916C22.773 23.2104 22.4762 23.3333 22.1668 23.3333H5.8335C5.52408 23.3333 5.22733 23.2104 5.00854 22.9916C4.78975 22.7728 4.66683 22.4761 4.66683 22.1667V17.5C4.66683 17.1906 4.54391 16.8938 4.32512 16.675C4.10633 16.4562 3.80958 16.3333 3.50016 16.3333C3.19074 16.3333 2.894 16.4562 2.6752 16.675C2.45641 16.8938 2.3335 17.1906 2.3335 17.5V22.1667C2.3335 23.0949 2.70225 23.9852 3.35862 24.6415C4.015 25.2979 4.90524 25.6667 5.8335 25.6667H22.1668C23.0951 25.6667 23.9853 25.2979 24.6417 24.6415C25.2981 23.9852 25.6668 23.0949 25.6668 22.1667V17.5C25.6668 17.1906 25.5439 16.8938 25.3251 16.675C25.1063 16.4562 24.8096 16.3333 24.5002 16.3333Z" fill="#716BE3" />
                                </svg>
                                {formData.xmlData ? <p className="para-onest-16 bold-600 color-746AFF">{nameFileXml}</p> : <p className="para-onest-16 bold-600 color-746AFF">{t('propertiesPage.uploadXML')} </p>}
                                <input className="form__file" id="upload-files" accept='.xml' type="file" onChange={handleFileChange} />
                            </label>
                            <div id="files-list-container"></div>
                        </div>
                        <div className="separator">{t("resizeImage.or")}</div>

                        <input type="text" className={`form-input border-CBD5E1 mt-4`}
                            placeholder={"URL"} name="URL"
                            onChange={(event) => setFormData((prevFormData) => ({
                                ...prevFormData,
                                url: event.target.value,
                            }))}
                            value={formData.url} />
                    </div>
                </div> :
                    <div className="custom-curl ">
                        <pre>
                            <code>
                                <span style={{ color: 'blue' }}>POST</span> /AddProperties HTTP/1.1 <br />
                                <span style={{ color: 'blue' }}>Host </span>: www.api-v1.coralytics.com<br />
                                <span style={{ color: 'blue' }}>Content-Type</span>: application/json <br />
                                <span style={{ color: 'blue' }}>Authorization</span>: Bearer {localStorage.getItem("usertoken")} <br />
                                {`{
  "jsonData": {
    "properties": [
      {
        "property": {
          "content": {
            "Address": {
              "community": "Community 1",
              "city": "City 1",
              "countryCode": "CC1",
              "latitude": 123.456,
              "longitude": 789.012,
              "subCommunity": "SubCommunity 1"
            },
            "category": {
              "id": 1,
              "name": "Category 1"
            },
            "createdAt": "2024-02-01T12:00:00Z",
            "desc": ["Description 1"],
            "images": [
              {
                "src": "https://www.api-v1.coralytics.com/api/images/65a5094da85636ed02cb8cad-0_1.jpg",
                "id": 1
              },
              {
                "src": "https://www.api-v1.coralytics.com/api/images/65a5094da85636ed02cb8cad-1_1.jpg",
                "id": 2
              }
            ],
            "offeringType": "Offering 1",
            "price": {
              "amount": 100000,
              "currency": "AED"
            },
            "bedrooms_count": 3,
            "bathrooms_count": 2,
            "size": {
              "value": 120,
              "unit": "sqt M"
            },
            "status": "active",
            "title": ["Title 1"],
            "url": "https://example.com/property1"
          },
          "user": {
            "companyName": "Company 1",
            "emailAddresses": ["user1@example.com"],
            "id": 123,
            "name": "User 1",
            "phoneNumbers": ["123-456-7890"],
            "sessionInfo": {
              "city": "City 1",
              "countryCode": "CC1",
              "ipAddress": "192.168.1.1",
              "postalCode": "12345",
              "region": "Region 1"
            }
          },
          "id": 1234567,
          "source": "Source 1"
        }
      }
    ]
  }
  }`}

                            </code>
                        </pre>
                    </div>}
            </DialogContent>
            {dialogType === "XML" && <DialogActions>
                <button type="button" onClick={() => { send(formData) }} className={`button-dash back-746AFF color-FFFFFF  border-746AFF padd-15 ${(formData.xmlData || formData.url) && formData.platform ? "" : "disabled"}`} data-bs-dismiss="modal">{t('propertiesPage.save')} </button>
            </DialogActions>}
        </BootstrapDialog>

    </>
    )
}
export default UploadProperties;
